import dayjs from 'dayjs';
import ReactDOM from 'react-dom';
import { doSentryInit } from 'src/config/doSentryInit';
import logToDataDog from 'src/config/logToDataDog';
import wrapWithStore from './wrapWithStore';

export default async function renderPage({
    component,
    el,
    initialState,
    postGaCustomMiddleware,
    preGaCustomMiddleware,
    reducers,
    renderComponent,
    routes,
    theme,
    pageName,
}) {
    const start = dayjs();
    doSentryInit();

    logToDataDog({
        name: 'booking-web-app.init-sentry-timing',
        type: 'histogram',
        value: dayjs().diff(start),
        tags: [`pageName:${pageName}`],
    });

    ReactDOM.render(
        wrapWithStore({
            component,
            initialState,
            postGaCustomMiddleware,
            preGaCustomMiddleware,
            reducers,
            renderComponent,
            routes,
            theme,
            pageName,
        }),
        el || document.getElementById('root')
    );
}
